// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/CreateEvent/CreateEvent.css
// module id = 1694
// module chunks = 0